<template>
  <div>
    <!-- <CircularSpinner :isLoading="isLoading" /> -->
    <HalfCircleSpinner :isLoading="isLoading" />
    <SnackbarNotifier />
    <div>
      <template>
        <AppBar :isFixed="!isGotRecommendedProducts" />
        <v-container
          fluid
          v-if="
            !isGotRecommendedProducts &&
            !($vuetify.breakpoint.smAndDown && isOpenQuestionnaireDialog)
          "
          class="home-container"
        >
          <!-- designed by using image -->
          <v-row class="d-flex flex-column justify-center align-center">
            <div class="diagnose-brewery-logo__container">
              <v-img
                :src="SakeBreweryLogo"
                alt="sake brewery name(i.e., sakagura)"
                contain
              >
              </v-img>
            </div>
            <div style="margin-top: 15px; z-index: 1">
              <p class="kurazake-title text-center">Kurazake Match</p>
            </div>
          </v-row>
          <v-row class="d-flex justify-center mt-6 mb-6">
            <v-btn
              @click="getStartedWithQuestionnaire"
              class="diagnose-button px-14 py-6 font-weight-medium"
              rounded
              dark
              color="#006934"
              :small="$vuetify?.breakpoint?.smAndDown"
            >
              <b>蔵酒 Match で診断する</b>
            </v-btn>
          </v-row>
          <FooterSection :isFixed="!isGotRecommendedProducts" />
        </v-container>
      </template>

      <template>
        <v-container class="questionnaire-container" fluid>
          <!-- for desktop view -->
          <v-dialog
            v-if="!$vuetify.breakpoint.smAndDown"
            v-model="isOpenQuestionnaireDialog"
            hide-overlay
            :persistent="true"
            :width="800"
          >
            <v-card>
              <v-card-title class="pb-4">
                <!-- Close icon aligned to the right -->
                <v-row no-gutters class="d-flex justify-end mb-2">
                  <v-icon
                    @click="isOpenQuestionnaireDialog = false"
                    class="cursor-pointer"
                  >
                    mdi-close
                  </v-icon>
                </v-row>

                <!-- Centered the questionnaire logo -->
                <div class="sake-brewery-small-logo__container">
                  <v-img
                    :src="SakeBreweryTopLogo"
                    alt="sake brewery name(i.e., sakagura)"
                    contain
                  >
                  </v-img>
                </div>
              </v-card-title>

              <v-card-text
                :class="[
                  'hvr-shutter-out-horizontal',
                  { active: isShowTasteProfileSectionMessage },
                ]"
                class="pb-0"
              >
                <div
                  class="mx-auto"
                  :style="{
                    width: $vuetify.breakpoint.smAndDown ? '80%' : '700px',
                  }"
                >
                  <v-progress-linear
                    :value="displayProgress"
                    class="mb-0 mt-0"
                    height="24"
                    color="#006934"
                    background-color="#B6AFAB"
                    style="border-radius: 25px"
                    dark
                  >
                    <strong>{{ `${Math.round(displayProgress)}%` }}</strong>
                  </v-progress-linear>
                </div>

                <v-form
                  ref="stepperForm"
                  v-model="isStepperFormValid"
                  class="mx-14"
                >
                  <v-stepper :elevation="0" v-model="currentStep">
                    <v-stepper-items>
                      <v-stepper-content
                        v-for="(step, index) in steps"
                        :key="index"
                        :step="index"
                        class="pt-8"
                      >
                        <div v-if="currentStep === index">
                          <p class="question-text text-center">
                            {{ `${step.question}` }}
                            <!-- {{ `${index + 1}. ${step.question}` }} -->
                          </p>
                          <div class="option-text">
                            <v-text-field
                              v-if="step.type === 'text'"
                              :label="step.question"
                              v-model="
                                questionnaireFormData[step.section_name][
                                  step.key
                                ]
                              "
                            ></v-text-field>
                            <v-radio-group
                              v-else-if="step.type === 'radio'"
                              dense
                              v-model="
                                questionnaireFormData[step.section_name][
                                  step.key
                                ]
                              "
                              :rules="[
                                (v) =>
                                  !!v ||
                                  'At least one option must be selected!',
                              ]"
                            >
                              <v-radio
                                v-for="(option, key) in step.options"
                                :key="key"
                                :label="option"
                                :value="key"
                              ></v-radio>
                            </v-radio-group>

                            <div v-else-if="step.type === 'checkbox'" fluid>
                              <v-checkbox
                                v-for="(option, key, index) in step.options"
                                :key="key"
                                multiple
                                dense
                                :hide-details="
                                  index !== Object.keys(step.options).length - 1
                                "
                                :label="option"
                                :value="key"
                                v-model="
                                  questionnaireFormData[step.section_name][
                                    step.key
                                  ]
                                "
                                :rules="[
                                  (v) =>
                                    (v && v.length > 0) ||
                                    'At least one option must be selected!',
                                ]"
                              >
                              </v-checkbox>
                            </div>

                            <!-- Dropdown Section -->
                            <div v-else-if="step.type === 'dropdown'" fluid>
                              <v-select
                                label="選択してください"
                                hide-details
                                solo
                                outlined
                                class="custom-dropdown"
                                v-model="
                                  questionnaireFormData[step.section_name][
                                    step.key
                                  ]
                                "
                                :items="
                                  Object.entries(step.options).map(
                                    ([key, value]) => ({
                                      text: value,
                                      value: key,
                                    })
                                  )
                                "
                                item-text="text"
                                item-value="value"
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'At least one option must be selected!',
                                ]"
                                @change="nextStep"
                              ></v-select>
                            </div>
                          </div>
                        </div>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                </v-form>
              </v-card-text>
              <!-- <div
                v-if="isShowTasteProfileSectionMessage"
                class="taste-profile-start-content"
              >
                <p>From now taste profile questions starts</p>
              </div>

              <v-divider></v-divider>

              <v-card-actions class="justify-end">
                <v-btn
                  @click="prevStep"
                  rounded
                  color="#007d3c"
                  dark
                  :disabled="currentStep === 0 || currentStep === steps.length"
                  :small="$vuetify?.breakpoint?.smAndDown"
                  >前へ</v-btn
                >
                <v-btn
                  :class="[{ 'd-none': isShowTasteProfileSectionMessage }]"
                  @click="nextStep"
                  rounded
                  color="#007d3c"
                  dark
                  v-if="currentStep < steps.length - 1"
                  :small="$vuetify?.breakpoint?.smAndDown"
                  >次へ</v-btn
                >
                <v-btn
                  @click="submit"
                  rounded
                  color="Black lighten-1"
                  dark
                  v-if="currentStep === steps.length - 1"
                  :small="$vuetify?.breakpoint?.smAndDown"
                  >送信</v-btn
                >
                <v-btn
                  v-show="isShowTasteProfileSectionMessage"
                  @click="removeShutterEffect"
                  color="#007d3c"
                  dark
                  :small="$vuetify?.breakpoint?.smAndDown"
                  >Next</v-btn
                >
              </v-card-actions> -->

              <v-card-actions class="justify-center pb-8">
                <!-- <v-btn
                  :class="[{ 'd-none': isShowTasteProfileSectionMessage }]"
                  class="px-10 py-4"
                  style="font-size: 21px"
                  @click="nextStep"
                  rounded
                  color="#007d3c"
                  dark
                  v-if="currentStep < steps.length - 1"
                  :small="$vuetify?.breakpoint?.smAndDown"
                  >次へ</v-btn
                > -->
                <v-btn
                  class="next-button px-14 py-6 font-weight-bold"
                  @click="submit"
                  rounded
                  color="#007d3c"
                  dark
                  v-if="currentStep === steps.length - 1 && isFinalStepAnswered"
                  :small="$vuetify?.breakpoint?.smAndDown"
                  >診断する</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- for mobile view -->
          <v-card
            v-else-if="
              $vuetify.breakpoint.smAndDown && isOpenQuestionnaireDialog
            "
            flat
          >
            <v-card-title>
              <!-- Close icon aligned to the right -->
              <!--<v-row no-gutters class="d-flex justify-end mb-2">
                <v-icon
                  @click="isOpenQuestionnaireDialog = false"
                  class="cursor-pointer"
                >
                  mdi-close
                </v-icon>
              </v-row>-->

              <!-- Centered the questionnaire logo -->
              <div class="sake-brewery-small-logo__container">
                <v-img
                  :src="SakeBreweryTopLogo"
                  alt="sake brewery name(i.e., sakagura)"
                  contain
                >
                </v-img>
              </div>
            </v-card-title>

            <v-card-text class="questionnaire-content">
              <div class="progressbar__container">
                <v-progress-linear
                  :value="displayProgress"
                  class="rounded-lg"
                  height="24"
                  color="#006934"
                  background-color="#B6AFAB"
                  dark
                >
                  <strong>{{ `${Math.round(displayProgress)}%` }}</strong>
                </v-progress-linear>
              </div>

              <v-form
                ref="stepperForm"
                v-model="isStepperFormValid"
                class="stepper-form"
              >
                <v-stepper :elevation="0" v-model="currentStep">
                  <v-stepper-items>
                    <v-stepper-content
                      v-for="(step, index) in steps"
                      :key="index"
                      :step="index"
                      class="stepper-content"
                    >
                      <div v-if="currentStep === index">
                        <p class="question-text text-center">
                          {{ `${step.question}` }}
                          <!-- {{ `${index + 1}. ${step.question}` }} -->
                        </p>
                        <div class="option-text">
                          <v-text-field
                            v-if="step.type === 'text'"
                            :label="step.question"
                            v-model="
                              questionnaireFormData[step.section_name][step.key]
                            "
                          ></v-text-field>
                          <v-radio-group
                            v-else-if="step.type === 'radio'"
                            v-model="
                              questionnaireFormData[step.section_name][step.key]
                            "
                            :rules="[
                              (v) =>
                                !!v || 'At least one option must be selected!',
                            ]"
                          >
                            <v-radio
                              v-for="(option, key) in step.options"
                              :key="key"
                              :label="option"
                              :value="key"
                            ></v-radio>
                          </v-radio-group>

                          <v-container
                            v-else-if="step.type === 'checkbox'"
                            fluid
                          >
                            <v-checkbox
                              v-for="(option, key, index) in step.options"
                              :key="key"
                              multiple
                              dense
                              :hide-details="
                                index !== Object.keys(step.options).length - 1
                              "
                              :label="option"
                              :value="key"
                              v-model="
                                questionnaireFormData[step.section_name][
                                  step.key
                                ]
                              "
                              :rules="[
                                (v) =>
                                  (v && v.length > 0) ||
                                  'At least one option must be selected!',
                              ]"
                            >
                            </v-checkbox>
                          </v-container>

                          <!-- Dropdown Section -->
                          <v-container
                            v-else-if="step.type === 'dropdown'"
                            fluid
                          >
                            <v-select
                              label="選択してください"
                              hide-details
                              solo
                              outlined
                              class="custom-dropdown"
                              v-model="
                                questionnaireFormData[step.section_name][
                                  step.key
                                ]
                              "
                              :items="
                                Object.entries(step.options).map(
                                  ([key, value]) => ({
                                    text: value,
                                    value: key,
                                  })
                                )
                              "
                              item-text="text"
                              item-value="value"
                              :rules="[
                                (v) =>
                                  !!v ||
                                  'At least one option must be selected!',
                              ]"
                              @change="nextStep"
                            ></v-select>
                          </v-container>
                        </div>
                      </div>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-form>
            </v-card-text>

            <v-card-actions class="justify-center">
              <!--<v-btn
                :class="[{ 'd-none': isShowTasteProfileSectionMessage }]"
                class="next-button px-14 py-6 font-weight-bold"
                style="z-index: 1"
                @click="nextStep"
                rounded
                color="#007d3c"
                dark
                v-if="currentStep < steps.length - 1"
                :small="$vuetify?.breakpoint?.smAndDown"
                >次へ</v-btn
              >-->
              <v-btn
                class="next-button px-14 py-6 font-weight-bold"
                style="z-index: 1"
                @click="submit"
                rounded
                color="#007d3c"
                dark
                v-if="currentStep === steps.length - 1 && isFinalStepAnswered"
                :small="$vuetify?.breakpoint?.smAndDown"
                >診断する</v-btn
              >
            </v-card-actions>
            <FooterSection
              :isFixed="!isGotRecommendedProducts"
              :isVisibleImage="
                !($vuetify.breakpoint.smAndDown && isOpenQuestionnaireDialog)
              "
            />
          </v-card>
        </v-container>

        <!-- Recommended Result Section -->
        <v-container
          class="recommendation__container"
          v-if="isGotRecommendedProducts"
          fluid
        >
          <v-card
            :elevation="$vuetify?.breakpoint?.smAndDown ? 0 : 3"
            :style="{
              margin: $vuetify?.breakpoint?.smAndDown ? '0' : '0 15rem',
            }"
            class="my-10"
          >
            <v-row class="d-flex justify-center">
              <v-col cols="12" sm="10" md="10" lg="10">
                <div
                  :class="[
                    $vuetify.breakpoint.xs ? 'text-body-2' : 'text-subtitle-1',
                  ]"
                >
                  <div class="sake-brewery-small-logo__container mx-auto mb-8">
                    <v-img
                      :src="SakeBreweryTopLogo"
                      alt="sake brewery name(i.e., sakagura)"
                      contain
                    >
                    </v-img>
                  </div>
                  <h2
                    class="mb-6 mt-4 font-weight-bold text-center green-heading-text"
                  >
                    あなたのタイプ
                  </h2>
                  <div>
                    <div>
                      <p class="random-comment">
                        {{ `${tasteProfileDetails.comment}` }}
                      </p>
                    </div>
                    <div class="pattern-type">
                      <div>
                        <p style="margin: 0 0 2rem 0;">{{ tasteProfileDetails.name }}</p>
                      </div>
                      <div>
                        <v-img
                        :src="createImagePath('character_images', this.classDetails[tasteProfileDetails.result].character_image)"
                        :alt="createImagePath('character_images', this.classDetails[tasteProfileDetails.result].character_image)"
                        height="12rem"
                        contain
                        ></v-img>
                      </div>
                      <div>
                        <v-img
                          :src="createImagePath('pattern_images_without_title', tasteProfileDetails.name)"
                          :alt="createImagePath('pattern_images_without_title', tasteProfileDetails.name)"
                          height="20rem"
                          contain
                        ></v-img>
                      </div>
                    </div>
                  </div>

                  <div class="mb-2 text-center">
                    <h2
                      class="green-heading-text mb-6 mt-2 mt-md-4 font-weight-bold"
                    >
                      タイプの特徴
                    </h2>
                    <v-row justify="center">
                      <v-col
                        cols="auto"
                        class="d-flex flex-column align-center"
                      >
                        <ul class="taste-characteristics">
                          <li
                            v-for="(
                              item, index
                            ) in tasteProfileDetails.characteristics"
                            :key="index"
                            class="text-center mb-4"
                          >
                            ＊ {{ item }}
                          </li>
                        </ul>
                      </v-col>
                    </v-row>
                  </div>
                  <div>
                    <p
                      class="mt-3 mt-md-4 pa-4 profile-explanation"
                      style="background-color: #dfedc9"
                    >
                      {{ tasteProfileDetails.explanation }}
                    </p>
                    <v-divider></v-divider>
                    <template>
                      <v-container>
                        <v-row class="d-flex justify-end">
                          <v-dialog
                            v-model="showFeedbackTextArea"
                            max-width="600px"
                          >
                            <v-card>
                              <v-card-title>
                                <span>
                                  <v-icon v-if="thumbsUp"
                                    >mdi-thumb-up-outline</v-icon
                                  >
                                  <v-icon v-else>mdi-thumb-down-outline</v-icon>
                                </span>
                                フィードバック
                                <v-spacer></v-spacer>
                                <!-- <v-menu bottom left>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                  <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                              </template>
                            </v-menu> -->
                              </v-card-title>
                              <v-card-text class="pb-0">
                                <v-textarea
                                  v-model="feedbackText"
                                  name="positive feedback"
                                  outlined
                                  auto-grow
                                  :placeholder="
                                    thumbsUp
                                      ? 'ご意見やご要望がございましたら、お気軽にお知らせください。'
                                      : 'ご意見やご要望がございましたら、お気軽にお知らせください。'
                                  "
                                ></v-textarea>
                              </v-card-text>
                              <v-card-actions class="py-4">
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="#006934"
                                  @click="proceedWithFeedbackText"
                                  dark
                                >
                                  送信
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                          <v-btn
                            color="#006934"
                            class="ma-2"
                            dark
                            icon
                            @click="handleThumbsUp"
                          >
                            <v-icon>{{
                              thumbsUp ? "mdi-thumb-up" : "mdi-thumb-up-outline"
                            }}</v-icon>
                          </v-btn>
                          <v-btn
                            color="#006934"
                            class="ma-2"
                            dark
                            icon
                            @click="handleThumbsDown"
                          >
                            <v-icon>{{
                              thumbsDown
                                ? "mdi-thumb-down"
                                : "mdi-thumb-down-outline"
                            }}</v-icon>
                          </v-btn>
                        </v-row>
                      </v-container>
                    </template>
                  </div>
                  <div class="d-flex flex-column align-center justify-center">
                    <v-chip-group
                      v-for="(values, type) in testProfileTypes"
                      :key="type"
                      class="me-1 me-sm-2 text-center"
                      column
                      multiple
                    >
                      <div class="text-center">
                        <!-- Taste Category Types Heading -->
                        <h2
                          v-if="
                            type == 'tasteCategoryTypes' && values.length > 0
                          "
                          :class="[$vuetify.breakpoint.xs ? 'mb-2' : 'mb-0']"
                          class="green-heading-text mb-2 font-weight-bold text-center"
                        >
                          おすすめの日本酒の味
                        </h2>
                        <!-- Manufacturing Category Types Heading -->
                        <h2
                          v-if="
                            type == 'manufacturingCategoryTypes' &&
                            values.length > 0
                          "
                          :class="[$vuetify.breakpoint.xs ? 'mb-2' : 'mb-0']"
                          class="green-heading-text mb-2 font-weight-bold text-center"
                        >
                          おすすめの日本酒の種類
                        </h2>
                        <!-- Chips -->
                        <div
                          :class="[
                            'mb-6 d-flex flex-wrap justify-center align-center font-weight-bold',
                            $vuetify?.breakpoint?.smAndDown
                              ? 'flex-column'
                              : '',
                          ]"
                        >
                          <v-chip
                            v-for="value in values"
                            :key="value"
                            outlined
                            small
                            :class="[$vuetify.breakpoint.xs ? 'small' : '']"
                            class="ma-1 px-4 py-2"
                            style="font-size: 17px"
                          >
                            {{ value }}
                          </v-chip>
                        </div>
                      </div>
                    </v-chip-group>
                  </div>
                </div>
              </v-col>
            </v-row>

            <div
              v-for="(allProducts, category) in recommendedProducts"
              :key="category"
            >
              <h2 class="mb-6 my-4 text-center green-heading-text">
                菊水のおすすめ
              </h2>
              <v-row class="d-flex justify-center mx-1">
                <v-col
                  v-for="product in allProducts"
                  :key="product?.item_id"
                  cols="12"
                  sm="10"
                  md="11"
                  lg="11"
                >
                  <ProductCard
                    :id="product?.item_id"
                    :name="product?.title"
                    :item_image="product?.image_url"
                    :price="product?.price"
                    :description="product?.description"
                    :tasteType="[product?.flavour_type.join('・')]"
                    :ingredientType="[product?.variant.join('・')]"
                    :volume="product?.volume"
                    :volumeVariant="product?.volume_variant"
                    :childItems="allChildItems?.[product?.item_id]"
                    :recommendedWayToDrink="product?.recommended_way_to_consume"
                    :recommendedJapaneseFood="product?.japanese_food"
                    :recommendedWesternFood="product?.western_food"
                    :recommendedChineseAndEthnicFood="
                      product?.chinese_and_ethnic_food
                    "
                    :recommendedSweetsAndFruit="product?.sweets_and_fruit"
                  />
                </v-col>
              </v-row>
            </div>
            <div>
              <v-row class="d-flex justify-center align-center my-8" dense>
                <v-btn
                  class="mx-2"
                  :small="$vuetify.breakpoint.smAndDown"
                  color="#3F51B5"
                  dark
                  @click="shareLink('Facebook')"
                >
                  <span class="mr-1 d-flex align-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 48 48"
                      style="vertical-align: middle"
                    >
                      <path
                        fill="currentColor"
                        d="M24,4C12.954,4,4,12.954,4,24c0,10.028,7.379,18.331,17,19.795V28h-5v-4h5v-3.677c0-4.96,2.954-7.693,7.467-7.693c2.134,0,3.666,0.139,4.161,0.202V17h-2.852c-2.404,0-2.876,1.144-2.876,2.822V24h5.775l-0.755,4H27v15.948C37.023,43.131,44,34.451,44,24C44,12.954,35.046,4,24,4z"
                      />
                    </svg>
                  </span>
                  <!-- <v-icon left>mdi-facebook</v-icon> -->
                  シェア
                </v-btn>

                <v-btn
                  class="mx-2"
                  :small="$vuetify.breakpoint.smAndDown"
                  color="#000000"
                  dark
                  @click="shareLink('Twitter')"
                >
                  <span class="mr-1 d-flex align-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      style="vertical-align: middle"
                    >
                      <path
                        fill="currentColor"
                        d="M10.053,7.988l5.631,8.024h-1.497L8.566,7.988H10.053z M21,21H3V3h18V21z M17.538,17l-4.186-5.99L16.774,7h-1.311l-2.704,3.16L10.552,7H6.702l3.941,5.633L6.906,17h1.333l3.001-3.516L13.698,17H17.538z"
                      />
                    </svg>
                  </span>
                  <!-- <v-icon left>mdi-twitter</v-icon> -->
                  ツイート
                </v-btn>

                <v-btn
                  :small="$vuetify.breakpoint.smAndDown"
                  class="mx-2"
                  color="#309c43"
                  dark
                  @click="shareLink('Line')"
                >
                  <span class="mr-1 d-flex align-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="10 11 27 23"
                      style="vertical-align: middle"
                    >
                      <path
                        fill="currentColor"
                        d="M37.113,22.417c0-5.865-5.88-10.637-13.107-10.637s-13.108,4.772-13.108,10.637c0,5.258,4.663,9.662,10.962,10.495c0.427,0.092,1.008,0.282,1.155,0.646c0.132,0.331,0.086,0.85,0.042,1.185c0,0-0.153,0.925-0.187,1.122c-0.057,0.331-0.263,1.296,1.135,0.707c1.399-0.589,7.548-4.445,10.298-7.611h-0.001C36.203,26.879,37.113,24.764,37.113,22.417z M18.875,25.907h-2.604c-0.379,0-0.687-0.308-0.687-0.688V20.01c0-0.379,0.308-0.687,0.687-0.687c0.379,0,0.687,0.308,0.687,0.687v4.521h1.917c0.379,0,0.687,0.308,0.687,0.687C19.562,25.598,19.254,25.907,18.875,25.907z M21.568,25.219c0,0.379-0.308,0.688-0.687,0.688s-0.687-0.308-0.687-0.688V20.01c0-0.379,0.308-0.687,0.687-0.687s0.687,0.308,0.687,0.687V25.219z M27.838,25.219c0,0.297-0.188,0.559-0.47,0.652c-0.071,0.024-0.145,0.036-0.218,0.036c-0.215,0-0.42-0.103-0.549-0.275l-2.669-3.635v3.222c0,0.379-0.308,0.688-0.688,0.688c-0.379,0-0.688-0.308-0.688-0.688V20.01c0-0.296,0.189-0.558,0.47-0.652c0.071-0.024,0.144-0.035,0.218-0.035c0.214,0,0.42,0.103,0.549,0.275l2.67,3.635V20.01c0-0.379,0.309-0.687,0.688-0.687c0.379,0,0.687,0.308,0.687,0.687V25.219z M32.052,21.927c0.379,0,0.688,0.308,0.688,0.688c0,0.379-0.308,0.687-0.688,0.687h-1.917v1.23h1.917c0.379,0,0.688,0.308,0.688,0.687c0,0.379-0.309,0.688-0.688,0.688h-2.604c-0.378,0-0.687-0.308-0.687-0.688v-2.603c0-0.001,0-0.001,0-0.001c0,0,0-0.001,0-0.001v-2.601c0-0.001,0-0.001,0-0.002c0-0.379,0.308-0.687,0.687-0.687h2.604c0.379,0,0.688,0.308,0.688,0.687s-0.308,0.687-0.688,0.687h-1.917v1.23H32.052z"
                      />
                    </svg>
                  </span>
                  <!-- <v-icon left>mdi-chat-outline</v-icon> -->
                  LINEで送る
                </v-btn>
              </v-row>
            </div>
            <div>
              <v-row class="d-flex justify-center align-center px-10">
                <v-col cols="12" md="10" lg="10">
                  <v-btn
                    class="mt-12 mb-10 py-6 font-weight-medium"
                    @click="resetSurvey"
                    rounded
                    dark
                    block
                    color="#006934"
                    :small="$vuetify?.breakpoint?.smAndDown"
                    :style="{
                      fontSize: $vuetify?.breakpoint?.smAndDown
                        ? '18px'
                        : '23px',
                    }"
                  >
                    <b>もう一度診断する</b>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-card>
          <FooterSection :isFixed="!isGotRecommendedProducts" />
        </v-container>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import ProductCard from "@/components/ProductCard.vue";
import CredentialsForm from "@/components/CredentialsForm.vue";
import CircularSpinner from "@/components/CircularSpinner.vue";
import SnackbarNotifier from "@/components/snackbar/SnackbarNotifier.vue";
import { CREDENTIALS_FORM_DATA, SNACKBAR_NOTIFIER } from "@/store/action_types";
import {
  encryptData,
  decryptData,
  generateShareableLink,
  extractDataFromToken,
} from "@/utils/encryptedShareableLink";
import { tasteClassification } from "@/utils/tasteClassificationInfo";
import { setRecommendationCountQueryParameter } from "@/utils/setQueryParameter";
import { getCurrentMonthJapanese } from "@/utils/retrieveCurrentMonth";
import { buildTastePattern } from "@/helpers/tastePatternCreate";
import { patternClassMap } from "@/helpers/pattern_mapping_with_class";
import SakeBreweryLogo from "@/assets/sakagura_logo.png";
import SakeBreweryTopLogo from "@/assets/sakagura_top_logo.png";
import HalfCircleSpinner from "@/components/HalfCircleSpinner.vue";
import AppBar from "@/components/AppBar.vue";
import FooterSection from "@/components/FooterSection.vue";

export default {
  name: "QuestionnairePage",
  components: {
    AppBar,
    FooterSection,
    CircularSpinner,
    HalfCircleSpinner,
    ProductCard,
    CredentialsForm,
    SnackbarNotifier,
  },
  data() {
    return {
      SakeBreweryLogo,
      SakeBreweryTopLogo,
      isCredentialsFormValid: "",
      requiredKeys: {
        item_id: "",
        title: "",
        image_url: "",
        price: "",
        description: "",
        flavour_type: "",
        variant: "",
        volume: "",
        volume_variant: "",
        child_items: "",
        // sweetness_dryness: "",
        // intensity_type: "",
        // ingredient_type: "",
        // manufacturing_type: "",
        recommended_way_to_consume: "",
        japanese_food: "",
        western_food: "",
        chinese_and_ethnic_food: "",
        sweets_and_fruit: "",
        cafemenu_shopmenu_shibataproducts: "",
        current_month: ""
      },
      isLoading: false,
      isOpenQuestionnaireDialog: false,
      currentStep: 0,
      questionnaireFormData: {},
      steps: [],
      displayProgress: 0,
      isStepValid: false,
      isStepperFormValid: true,
      questionnaireName: "",
      isGotRecommendedProducts: false,
      recommendedProducts: {},
      testProfileTypes: {},
      tasteProfileDetails: {},
      profileQuestionnaire: {},
      thumbsUp: false,
      thumbsDown: false,
      showFeedbackTextArea: false,
      feedbackText: "",
      classDetails: tasteClassification,
      lastSelectedCommentIndex: -1,
      lastSelectedTasteCategory: "",
      isShowTasteProfileSectionMessage: false,
      allChildItems: {},
      currentQueryParamValue: this.$route.query.recommend_count || 3,
    };
  },
  beforeCreate() {},
  created() {
    setRecommendationCountQueryParameter(this);
  },
  mounted() {},
  computed: {
    ...mapGetters("credentials_form", [
      "isOpenCredentialsForm",
      "credentialsFromData",
      "isValidCredentialsForm",
    ]),

    progressCalculate() {
      if (this.steps.length === 0) {
        return 0;
      }
      let calculate = (this.currentStep / this.steps.length) * 100;
      return calculate;
    },
    isFinalStepAnswered() {
      const finalStep = this.steps[this.steps.length - 1];
      const value =
        this.questionnaireFormData?.[finalStep.section_name]?.[finalStep.key];
      return value !== null && value !== undefined && value !== "";
    },
  },
  methods: {
    ...mapActions("snackbar_notifier", [SNACKBAR_NOTIFIER]),
    ...mapActions("credentials_form", [CREDENTIALS_FORM_DATA]),

    resetSurvey() {
      window.location.reload();
    },

    async nextStep() {
      const isValid = await this.$refs.stepperForm.validate();
      // if (
      //   this.isShowTasteProfileSectionMessage === true &&
      //   this.currentStep === 20
      // ) {
      //   this.showSnackbarNotifier(
      //     "Please press the continue button to proceed!",
      //     "warning",
      //     2000
      //   );
      //   return;
      // }
      if (!isValid) return;

      if (this.currentStep < this.steps.length - 1) {
        this.currentStep++;
      }

      console.log("this.questionnaireFormData:\n", this.questionnaireFormData);
    },
    async prevStep() {
      if (this.currentStep > 0) {
        if (this.currentStep == 20) {
          this.isShowTasteProfileSectionMessage = false;
        }
        this.currentStep--;
      }
    },
    async removeShutterEffect() {
      this.isShowTasteProfileSectionMessage = false;
    },
    createImagePath(directory, imageName) {
      try {
        if (!imageName) return "";
        
        // Check if filename already has an extension
        const hasExtension = /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(imageName);
        
        // Use the filename as-is if it has an extension, otherwise append .jpg
        const fileName = hasExtension ? imageName : `${imageName}.jpg`;
        
        // Return the required path
        return require(`@/assets/${directory}/${fileName}`);
      } catch (error) {
        console.warn(`Image not found: @/assets/${directory}/${imageName}`, error);
        return "";
      }
    },
    // processTasteProfile(data) {
    //   console.log("processTasteProfile:", data);
    //   const tasteTypes = new Set();
    //   const ingredientTypes = new Set();

    //   Object.values(data).forEach((products) =>
    //     products.forEach((product) => {
    //       // (product.sweetness_dryness || []).forEach((type) =>
    //       //   tasteTypes.add(type)
    //       // );
    //       // (product.ingredient_type || []).forEach((type) =>
    //       //   ingredientTypes.add(type)
    //       // );
    //       const sweetnessDryness = product.sweetness_dryness?.join("・") || "";
    //       const intensityType = product.intensity_type?.join("・") || "";

    //       // Combine sweetness_dryness and intensity_type with "・"
    //       const combinedTaste = [sweetnessDryness, intensityType]
    //         .filter((part) => part) // Remove empty parts
    //         .join("・");
    //       if (combinedTaste) {
    //         tasteTypes.add(combinedTaste);
    //       }
    //       (product.ingredient_type || []).forEach((type) =>
    //         ingredientTypes.add(type)
    //       );
    //     })
    //   );
    //   console.log("tasteTypes --> ", { tasteTypes });
    //   console.log("ingredientTypes --> ", { ingredientTypes });
    //   return {
    //     tasteTypes: [...tasteTypes],
    //     ingredientTypes: [...ingredientTypes],
    //   };
    // },

    processTasteProfile(data) {
      console.log("processTasteProfile:", data);

      const tasteTypes = new Set();
      const manufacturingProcesses = new Set();

      Object.values(data)
        .flat()
        .forEach((product) => {
          if (product.flavour_type?.length > 0) {
            tasteTypes.add(product.flavour_type.join("・"));
          }
          if (product.variant?.length > 0) {
            manufacturingProcesses.add(product.variant.join("・"));
          }
        });

      console.log("tasteCategoryTypes:", Array.from(tasteTypes));
      console.log(
        "manufacturingCategoryTypes:",
        Array.from(manufacturingProcesses)
      );

      return {
        tasteCategoryTypes: Array.from(tasteTypes),
        manufacturingCategoryTypes: Array.from(manufacturingProcesses),
      };
    },

    async extractingGptResponse(gptResponse) {
      console.log("gptResponse:", gptResponse);
      let responseString = gptResponse?.detail?.response;

      // Check and clean the response string
      if (responseString && responseString.startsWith("```")) {
        responseString = responseString
          .replace(/^```(json)?\n/, "") // Remove starting markers
          .replace(/\n```$/, ""); // Remove trailing markers
      }

      // Log the cleaned string to check if it's valid JSON
      console.log("Cleaned response string:", responseString);

      try {
        const sanitizedString = responseString.replace(/'/g, '"');
        const responseObject = JSON.parse(sanitizedString); // Try parsing
        console.log("Parsed response:", responseObject); // Log the parsed object

        const className = this.classDetails[responseObject?.result]?.name;
        const characteristicsList =
          this.classDetails[responseObject?.result]?.characteristics;
        // const characteristicsList = characteristicsText.split("\n");
        const categoriesList = responseObject?.categories
          ? responseObject?.categories.split(",")
          : [];
        const resultType = responseObject?.result;
        const selectComment = await this.getRandomComment(resultType);
        return {
          conversationId: gptResponse?.detail?.conversation_id,
          result: responseObject.result,
          name: className,
          characteristics: characteristicsList,
          comment: selectComment,
          explanation: responseObject.explanation,
          preferredCategories: categoriesList,
        };
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    },
    async getRandomComment(tasteClass) {
      const recommendedComments = this.classDetails[tasteClass].comments;
      if (recommendedComments.length < 2) return recommendedComments[0];

      let randomIndex;
      do {
        randomIndex = Math.floor(Math.random() * recommendedComments.length);
      } while (
        randomIndex === this.lastSelectedCommentIndex &&
        tasteClass === this.lastSelectedTasteCategory
      ); // Ensure it's not the same as last pick

      // Update the stored index and class for future checks
      this.lastSelectedCommentIndex = randomIndex;
      this.lastSelectedTasteCategory = tasteClass;

      return recommendedComments[randomIndex];
    },
    async processingRecommendations(recommendations) {
      console.log("processing recommendations: ", recommendations);
      const processedRecommendations = {};

      Object.entries(recommendations).forEach(([category, products]) => {
        processedRecommendations[category] = products.map((product) => ({
          item_id: product[this.requiredKeys.item_id],
          title: product[this.requiredKeys.title],
          image_url: product[this.requiredKeys.image_url],
          price: product[this.requiredKeys.price],
          description: product[this.requiredKeys.description],
          flavour_type: product[this.requiredKeys.flavour_type],
          variant: product[this.requiredKeys.variant],
          volume: product[this.requiredKeys.volume],
          volume_variant: product[this.requiredKeys.volume_variant],
          child_items: product[this.requiredKeys.child_items],
          // sweetness_dryness: product[this.requiredKeys.sweetness_dryness],
          // intensity_type: product[this.requiredKeys.intensity_type],
          // ingredient_type: product[this.requiredKeys.ingredient_type],
          // manufacturing_type: product[this.requiredKeys.manufacturing_type],
          recommended_way_to_consume:
            product[this.requiredKeys.recommended_way_to_consume],
          japanese_food: product[this.requiredKeys.japanese_food],
          western_food: product[this.requiredKeys.western_food],
          chinese_and_ethnic_food:
            product[this.requiredKeys.chinese_and_ethnic_food],
          sweets_and_fruit: product[this.requiredKeys.sweets_and_fruit],
          cafemenu_shopmenu_shibataproducts: product[this.requiredKeys.cafemenu_shopmenu_shibataproducts],
          current_month_value: product[this.requiredKeys.current_month],
          score: product["score"],
        }));
      });

      return processedRecommendations;
    },

    async selectingTop3Categories(
      processedRecommendations,
      preferredTopCategories
    ) {
      console.log("preferredTopCategories: ", preferredTopCategories);
      let top3Categories = [];
      // Step 1: Filter categories with items
      const categoriesWithItems = Object.entries(
        processedRecommendations
      ).reduce((result, [key, value]) => {
        if (value.length > 0) result[key] = value;
        return result;
      }, {});
      console.log("categoriesWithItems: ", categoriesWithItems);

      // Step 2: Find max score for each category
      const categoriesMaxScore = Object.entries(categoriesWithItems).map(
        ([category, items]) => {
          const maxScore = Math.max(...items.map((item) => item.score));
          return { category, maxScore };
        }
      );
      console.log("categoriesMaxScore: ", categoriesMaxScore);

      // Step 3: Sort categories by max score (descending order)
      categoriesMaxScore.sort((a, b) => b.maxScore - a.maxScore);

      // Select the top 3 categories based on the max score
      /* const top3MaxScoreCategories = categoriesMaxScore
        .slice(0, 3)
        .map((item) => item.category);
      console.log("top3Categories: ", top3MaxScoreCategories); */

      // Step 4: Cross-check preferredTopCategories and categoriesWithItems
      const matchedPreferredTopCategories = preferredTopCategories.filter(
        (category) => categoriesWithItems[category]
      );
      console.log(
        "matchedPreferredTopCategories: ",
        matchedPreferredTopCategories
      );

      // Adding preferred categories to the top of the list
      top3Categories.push(...matchedPreferredTopCategories);
      top3Categories.push(
        ...categoriesMaxScore
          .filter(
            ({ category }) => !matchedPreferredTopCategories.includes(category)
          )
          .slice(0, 3 - matchedPreferredTopCategories.length) // Ensure we only add enough to make 3 categories
          .map(({ category }) => category)
      );
      console.log("Top 3 Categories: ", top3Categories);
      return top3Categories;
    },
    separateSurveyData(data) {
      console.log("separateSurveyData: ", data);
      const sectionNames = Object.keys(data);
      const recommendationData = data[sectionNames[0]];

      const mappingForRecommendation = {
        q1: "q1",
        q2: "q2",
        q3: "q3",
        q4: "q4",
        q5: "q5",
        q6: "q6",
        q7: "q7",
        q8: "q8",
        q9: "q9",
        q10: "q10",
        q11: "q11",
        q12: "q12",
        q13: "q13",
        q14: "q14",
        q15: "q15",
      };

      const mappingForAskTasteCategory = {
        q1: "q1",
        q2: "q2",
        q3: "q3",
        q4: "q4",
        q5: "q5",
        q6: "q6",
        q7: "q7",
        q8: "q8",
        q9: "q9",
        q10: "q10",
        q11: "q11",
        q12: "q12",
        q13: "q13",
        q14: "q14",
        q15: "q15",
      };

      // Create the recommendation profile
      let recommendationProfileAnswers = {};
      for (const [oldKey, newKey] of Object.entries(mappingForRecommendation)) {
        if (recommendationData[oldKey] !== undefined) {
          recommendationProfileAnswers[newKey] = recommendationData[oldKey];
        }
      }

      // Create the taste category profile
      let askTasteCategoryProfileAnswers = {};
      for (const [oldKey, newKey] of Object.entries(
        mappingForAskTasteCategory
      )) {
        if (recommendationData[oldKey] !== undefined) {
          askTasteCategoryProfileAnswers[newKey] = recommendationData[oldKey];
        }
      }

      console.log(
        "recommendationProfileAnswers: ",
        recommendationProfileAnswers
      );
      console.log(
        "askTasteCategoryProfileAnswers: ",
        askTasteCategoryProfileAnswers
      );

      // Return the structure with the dynamic key, maintaining the correct format
      return {
        recommendationBody: {
          [sectionNames[0]]: recommendationProfileAnswers,
        },
        tasteCategoryBody: askTasteCategoryProfileAnswers,
      };
    },

    /**
     * Generate query string from questionnaire answers
     * @param {Object} answers - Answers object containing question responses
     * @param {Boolean} onlyTasteQuestions - If true, only include Q8-Q15 (taste pattern questions)
     * @returns {string} Query string formatted as Q&A pairs
     */
    generateQuery(answers, onlyTasteQuestions = false) {
      const questions = this.profileQuestionnaire.questions.profile_questions;

      // Helper function to get the answer text
      const getAnswerText = (questionKey, answerKey) => {
        const options = questions[questionKey]?.options || {};
        if (Array.isArray(answerKey)) {
          return answerKey.map((key) => options[key]).join(", ");
        }
        return options[answerKey] || "";
      };

      // Template rendering
      const renderQuestion = (index, questionText, answerText) =>
        `Q${index}: ${questionText}\nA${index}: ${answerText}`;

      // Determine which questions to include
      const questionsToProcess = onlyTasteQuestions
        ? ["q8", "q9", "q10", "q11", "q12", "q13", "q14", "q15"]
        : Object.keys(questions);

      // Build the query
      const query = questionsToProcess
        .map((key, index) => {
          const questionText = questions[key]?.question || "";
          const answerText = getAnswerText(key, answers[key]) || "";
          // For taste questions, use index offset of 8; for all questions, use index + 1
          const questionNumber = onlyTasteQuestions ? (8 + index) : (index + 1);
          return renderQuestion(questionNumber, questionText, answerText);
        })
        .join("\n\n");

      return query.trim();
    },

    /**
     * Build the taste pattern string from Q8-Q15 answers
     * Pattern format: "苦_苦酸_旨_旨塩_旨_塩_旨_旨"
     * 
     * @returns {string} The generated taste pattern or empty string if error occurs
     */
    getTastePattern() {
      try {
        const pattern = buildTastePattern(
          this.profileQuestionnaire,
          this.questionnaireFormData.profile_questions || {}
        );
        return pattern;
      } catch (error) {
        console.error("Error building taste pattern:", error);
        return "";
      }
    },

    /**
     * Get the taste classification class based on the generated pattern
     * Maps pattern to class like "U_4", "B_1", etc.
     * Returns "B_1" as default if pattern not found in mapping
     * 
     * @returns {string} The classification class (default: "B_1")
     */
    getTasteClassFromPattern(pattern) {
      try {
        if (!pattern) {
          console.warn("No pattern generated, using default class: B_1");
          return "B_1";
        }
        
        const tasteClass = patternClassMap.get(pattern) ?? "B_1";
        
        if (patternClassMap.has(pattern)) {
          console.log("============ TASTE PATTERN ANALYSIS ============");
          console.log(`Pattern "${pattern}" maps to class: ${tasteClass}`);
          console.log("================================================\n");
        } else {
          console.warn(`No class mapping found for pattern: ${pattern}, using default class: B_1`);
        }
        return tasteClass;
      } catch (error) {
        console.error("Error getting taste class:", error);
        return "B_1";
      }
    },

    submit() {
      const isValid = this.$refs.stepperForm.validate();
      if (!isValid) return;

      this.currentStep++;
      setTimeout(() => {
        this.isOpenQuestionnaireDialog = false;
        console.log("My Questionnaire Answers:\n", this.questionnaireFormData); // working
      }, 500);

      this.isLoading = true;

      const headers = {
        accept: "application/json",
        "Content-Type": "application/json",
        "project-key": this.credentialsFromData["projectKey"],
        "api-key": this.credentialsFromData["apiKey"],
      };
      const surveyResults = this.separateSurveyData(this.questionnaireFormData);
      console.log(
        "recommendationBody:",
        JSON.stringify(surveyResults.recommendationBody, null, 2)
      );
      console.log(
        "tasteCategoryBody:",
        JSON.stringify(surveyResults.tasteCategoryBody, null, 2)
      );

      // Generate taste pattern and get corresponding class
      const tastePattern = this.getTastePattern();
      const tasteClass = this.getTasteClassFromPattern(tastePattern);

      // Build enhanced query with ONLY Q8-Q15 and pattern/class information
      const tastePatternQuery = this.generateQuery(
        surveyResults.tasteCategoryBody,
        false // onlyTasteQuestions = true to get only Q8-Q15
      );
      const enhancedQuery = `${tastePatternQuery}\n\nAnalyze the taste pattern: '${tastePattern}' based on the answers from Q8 to Q15 respectively, and select the most appropriate class. The result class should be '${tasteClass}' for this answer pattern`;
      console.log("Enhanced Stringified Query for GPT:\n", JSON.stringify(enhancedQuery));
      const {
        item_id,
        title,
        image_url,
        price,
        description,
        flavour_type,
        variant,
        volume,
        volume_variant,
        child_items,
        // sweetness_dryness,
        // intensity_type,
        // ingredient_type,
        // manufacturing_type,
        recommended_way_to_consume,
        japanese_food,
        western_food,
        chinese_and_ethnic_food,
        sweets_and_fruit,
        cafemenu_shopmenu_shibataproducts,
        current_month,
      } = this.requiredKeys;

      const resultIncludedColumns =
        flavour_type === "N/A"
          ? [item_id, title, image_url, price, description]
          : [
              item_id,
              title,
              image_url,
              price,
              description,
              flavour_type,
              variant,
              volume,
              volume_variant,
              child_items,
              // sweetness_dryness,
              // intensity_type,
              // ingredient_type,
              // manufacturing_type,
              recommended_way_to_consume,
              japanese_food,
              western_food,
              chinese_and_ethnic_food,
              sweets_and_fruit,
              cafemenu_shopmenu_shibataproducts,
              current_month,
            ];
      console.log("resultIncludedColumns: ", resultIncludedColumns);
      const requestBody = {
        user_id: this.$root.userId,
        // member_id: this.$root.memberId,
        questionnaire_id: this.credentialsFromData["questionnaireId"],
        values: surveyResults.recommendationBody,
        recommend_count:
          this.$route.query.recommend_count || this.currentQueryParamValue,
        result_includes: resultIncludedColumns, // result_includes: ["JANコード", "商品名", "images", "参考価格", "商品説明(60文字)", "タイプ", "種類", "容量", "その他の容量項目"."容量バリアント", "甘辛区分", "濃淡区分", "特定名称","製造区分", "飲み頃温度", "和食", "洋食", "中華_エスニック", "スイーツ_フルーツ" ],
        top_k: 20,
        is_keyword_enabled: false,
      };
      axios
        .post(
          `${process.env.VUE_APP_RECOMMENDER_API}/v1/questionnaire/recommend`,
          requestBody,
          {
            headers,
          }
        )
        .then((response) => {
          if (response.data.request_id) {
            this.$root.requestId = response.data.request_id;
            console.log("recommendations response:\n", response.data);
            const recommendations = response.data?.detail?.recommendations;

            let getProcessedRecommendation =
              this.processingRecommendations(recommendations);

            // GPT ask request body with enhanced query including pattern and class
            const gptRequestBody = {
              user_id: this.$root.userId,
              // member_id: this.$root.memberId,
              query: JSON.stringify(enhancedQuery),
              conversation_type: "question",
              gpt_profile_id: process.env.VUE_APP_MAIRA_GPT_PROFILE_ID,
              context_preference: {
                preferred: {
                  dataset_id: process.env.VUE_APP_MAIRA_DATASET_ID,
                },
              },
            };

            return Promise.all([
              getProcessedRecommendation,
              axios.post(
                `${process.env.VUE_APP_RECOMMENDER_API}/v1/gpt/ask`,
                gptRequestBody,
                {
                  headers,
                }
              ),
            ]);
          }
        })
        .then(async ([getProcessedRecommendation, gptResponse]) => {
          console.log("processed recommendations:\n", await getProcessedRecommendation);
          console.log("gpt response:\n", await gptResponse.data);
          if (gptResponse) {
            this.$root.conversationId =
              gptResponse.data?.detail?.conversation_id;
            const {
              conversationId,
              result,
              name,
              characteristics,
              explanation,
              comment,
              preferredCategories,
            } = await this.extractingGptResponse(gptResponse.data);

            this.tasteProfileDetails = {
              conversationId,
              result,
              name,
              characteristics,
              explanation,
              comment,
              preferredCategories,
            };
            console.log("tasteProfileDetails", this.tasteProfileDetails);

            // const processedTop3CategoriesRecommendations = {};

            // let getTop3Categories = await this.selectingTop3Categories(
            //   getProcessedRecommendation,
            //   preferredCategories
            // );

            // getTop3Categories.forEach((category) => {
            //   processedTop3CategoriesRecommendations[category] =
            //     getProcessedRecommendation[category];
            // });

            // this.testProfileTypes = this.processTasteProfile(
            //   processedTop3CategoriesRecommendations
            // );

            // this.recommendedProducts = processedTop3CategoriesRecommendations;

            const recommendationItemsToDisplay =
              await this.processedToShowingRecommendationItems(
                getProcessedRecommendation,
                preferredCategories
              );
            this.testProfileTypes = this.processTasteProfile(
              recommendationItemsToDisplay
            );
            this.recommendedProducts = recommendationItemsToDisplay;
            this.allChildItems = await this.processChildItems(
              recommendationItemsToDisplay
            );
            console.log("allChildItems", this.allChildItems);
          }

          this.isGotRecommendedProducts = true;
        })
        .catch((error) => {
          console.error("There was an error submitting the data!", error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    /* async processedToShowingRecommendationItems(
      getProcessedRecommendation,
      preferredCategories
    ) {
      const processedRecommendations = {};

      // Get top 3 categories
      let getTop3Categories = await this.selectingTop3Categories(
        getProcessedRecommendation,
        preferredCategories
      );

      // Determine how many products to show based on getRecommendCount
      const recommendationsPerCategory = this.currentQueryParamValue;
      console.log("recommendationsPerCategory: ", recommendationsPerCategory);

      // Counter to track how many additional products we need
      let additionalProductsNeeded = 0;

      // Process first category
      const firstCategory = getTop3Categories[0];
      const firstCategoryProducts =
        getProcessedRecommendation[firstCategory].slice(
          0,
          recommendationsPerCategory
        ) || [];

      // Add all available products from first category
      processedRecommendations[firstCategory] = firstCategoryProducts;

      // Calculate how many more products we need if first category has less than required amount
      if (firstCategoryProducts.length < recommendationsPerCategory) {
        additionalProductsNeeded =
          recommendationsPerCategory - firstCategoryProducts.length;

        // Try to get additional products from second category
        if (additionalProductsNeeded > 0 && getTop3Categories.length > 1) {
          const secondCategory = getTop3Categories[1];
          const secondCategoryProducts =
            getProcessedRecommendation[secondCategory] || [];

          // Take required number of products from second category
          const productsFromSecondCategory = secondCategoryProducts.slice(
            0,
            additionalProductsNeeded
          );

          // Add these products to first category's array
          processedRecommendations[firstCategory] = [
            ...firstCategoryProducts,
            ...productsFromSecondCategory,
          ];

          // If we still need more products and we're showing 5 recommendations
          let remainingNeeded =
            recommendationsPerCategory -
            (firstCategoryProducts.length + productsFromSecondCategory.length);

          if (remainingNeeded > 0 && getTop3Categories.length > 2) {
            const thirdCategory = getTop3Categories[2];
            const thirdCategoryProducts =
              getProcessedRecommendation[thirdCategory] || [];

            // Take required number of products from third category
            const productsFromThirdCategory = thirdCategoryProducts.slice(
              0,
              remainingNeeded
            );

            // Add these products to first category's array
            processedRecommendations[firstCategory] = [
              ...processedRecommendations[firstCategory],
              ...productsFromThirdCategory,
            ];
          }
        }
      }
      return processedRecommendations;
    }, */
    async processedToShowingRecommendationItems(
      getProcessedRecommendation,
      preferredCategories
    ) {
      let processedShowingRecommendations = {};

      // Step 1: Filter out items with current_month_value === 0 and empty categories
      const filteredRecommendations = Object.entries(getProcessedRecommendation).reduce((acc, [category, products]) => {
        const filteredProducts = products.filter(item => item.current_month_value !== 0);
        if (filteredProducts.length > 0) {
          acc[category] = filteredProducts;
        }
        return acc;
      }, {});
      console.log("processed recommendation after filter out:\n", filteredRecommendations);

      // Step 2: Get top 3 categories
      const getTop3Categories = await this.selectingTop3Categories(filteredRecommendations, preferredCategories);

      // Step 3: Get the number of recommendations to show
      const recommendationsPerCategory = this.currentQueryParamValue;
      console.log("recommendations per category: ", recommendationsPerCategory);

      // Step 4: Collect prioritized products (current_month_value === 2 only)
      let prioritizedProducts = [];
      const alreadyIncludedItems = new Set();

      for (const cat of getTop3Categories) {
        const catItems = filteredRecommendations[cat] || [];
        for (const item of catItems) {
          if (item.current_month_value === 2 && !alreadyIncludedItems.has(item.item_id)) {
            prioritizedProducts.push(item);
            alreadyIncludedItems.add(item.item_id);
            if (prioritizedProducts.length === recommendationsPerCategory) break;
          }
        }
        if (prioritizedProducts.length === recommendationsPerCategory) break;
      }

      // Step 5: Strictly fill from top category first until total reached
      if (prioritizedProducts.length < recommendationsPerCategory) {
        let additionalNeeded = recommendationsPerCategory - prioritizedProducts.length;

        for (const cat of getTop3Categories) {
          if (additionalNeeded === 0) break;

          const catItems = filteredRecommendations[cat] || [];
          for (const item of catItems) {
            if (!alreadyIncludedItems.has(item.item_id)) {
              prioritizedProducts.push(item);
              alreadyIncludedItems.add(item.item_id);
              additionalNeeded--;
              if (additionalNeeded === 0) break;
            }
          }
        }
      }
      // Step 6: Return final grouped result under "recommendations"
      processedShowingRecommendations["recommendations"] = prioritizedProducts.slice(0, recommendationsPerCategory);

      return processedShowingRecommendations;
    },
    async processChildItems(recommendedProducts) {
      try {
        const headers = {
          accept: "application/json",
          "project-key": this.credentialsFromData["projectKey"],
          "api-key": this.credentialsFromData["apiKey"],
        };

        const childItemsMap = {};

        for (const category in recommendedProducts) {
          for (const item of recommendedProducts[category]) {
            if (item.child_items && item.child_items.length > 0) {
              const cleanedIds = item.child_items.map((id) => id.trim());
              const response = await axios.post(
                `${process.env.VUE_APP_RECOMMENDER_API}/v1/items`,
                { ids: cleanedIds },
                { headers }
              );
              childItemsMap[item.item_id] =
                response.data?.detail?.response || [];
            } else {
              childItemsMap[item.item_id] = [];
            }
          }
        }
        return childItemsMap;
      } catch (error) {
        console.error("Error processing child items:", error);
        throw error;
      }
    },

    showSnackbarNotifier(message, color, duration) {
      this.SNACKBAR_NOTIFIER({
        data: {
          isShow: true,
          message: message,
          color: color,
          duration: duration,
        },
      });
    },

    initializeFormData() {
      const data = {};
      this.steps.forEach((step) => {
        if (!data[step.section_name]) {
          data[step.section_name] = {};
        }
        data[step.section_name][step.key] =
          step.type === "checkbox" ? [] : null;
      });
      return data;
    },

    async getStartedWithQuestionnaire() {
      console.log(this.credentialsFromData, "Home page credentialsFromData");
      console.log(this.isValidCredentialsForm, "isValidCredentialsForm");

      const isAllFieldsEmpty =
        !this.credentialsFromData?.questionnaireId ||
        !this.credentialsFromData?.projectKey ||
        !this.credentialsFromData?.apiKey;

      if (isAllFieldsEmpty) {
        this.showSnackbarNotifier(
          "Please fill in all required credentials before performing this action!",
          "warning",
          2000
        );
        return;
      }
      this.questionnaireFormData = this.initializeFormData();
      this.currentStep = 0;
      this.isLoading = true;
      this.isGotRecommendedProducts = false;
      await this.getResultIncludesKeysByMapper();
      await this.fetchQuestionnaire();
    },

    fetchQuestionnaire() {
      // let Id = this.credentialsFromData["questionnaireId"];
      // const headers = {
      //   accept: "application/json",
      //   "project-key": this.credentialsFromData["projectKey"],
      //   "api-key": this.credentialsFromData["apiKey"],
      // };
      // axios
      //   .get(`${process.env.VUE_APP_RECOMMENDER_API}/v1/questionnaires/${Id}`, {
      //     headers,
      //   })
      axios
        .get("./data/questionnaire_v3.json")
        .then((response) => {
          console.log("Questionnaires Response:\n", response.data);
          this.profileQuestionnaire = response.data;
          const { name, questions } = response.data;
          this.steps = [];
          this.questionnaireName = name;

          Object.entries(questions).forEach(([section_name, questions_set]) => {
            if (!this.questionnaireFormData[section_name]) {
              console.log("inside", {
                ...this.questionnaireFormData[section_name],
              });
              this.$set(this.questionnaireFormData, section_name, {});
              // Process questions in each category_section
              Object.entries(questions_set).forEach(([key, value]) => {
                this.steps.push({ section_name, key, ...value });
                if (value.type === "checkbox") {
                  this.$set(this.questionnaireFormData[section_name], key, []);
                } else {
                  this.$set(this.questionnaireFormData[section_name], key, "");
                }
              });
            } else {
              // No need to reset the entire section, just ensure existing data is maintained
              Object.entries(questions_set).forEach(([key, value]) => {
                this.steps.push({ section_name, key, ...value });
                if (!(key in this.questionnaireFormData[section_name])) {
                  if (value.type === "checkbox") {
                    this.$set(
                      this.questionnaireFormData[section_name],
                      key,
                      []
                    );
                  } else {
                    this.$set(
                      this.questionnaireFormData[section_name],
                      key,
                      ""
                    );
                  }
                }
              });
              console.log("outside", {
                ...this.questionnaireFormData[section_name],
              });
            }
          });

          console.log("Steps setup complete: ", this.steps);
          console.log(
            "questionnaireFormData setup complete: ",
            this.questionnaireFormData
          );
        })
        .catch((error) => {
          console.error("There was an error fetching the data!", error);
        })
        .finally(() => {
          setTimeout(() => {
            this.isLoading = false; // Turn off loader
            this.isOpenQuestionnaireDialog = true; // Open Questionnaire Dialog after 1 seconds
          }, 1000);
        });
    },

    getResultIncludesKeysByMapper() {
      const headers = {
        accept: "application/json",
        "project-key": this.credentialsFromData["projectKey"],
        "api-key": this.credentialsFromData["apiKey"],
      };
      axios
        .get(`${process.env.VUE_APP_RECOMMENDER_API}/v1/mappers`, {
          headers,
        })
        .then((response) => {
          console.log("Get Mapper Keys Response: \n", response.data);
          const responseDetails = response.data?.detail?.response;
          const { item_id, title, image_url, price, description, categories } =
            responseDetails;
          console.log("categories", categories);
          this.requiredKeys.item_id = item_id;
          this.requiredKeys.title = title;
          this.requiredKeys.image_url = image_url;
          this.requiredKeys.price = price;
          this.requiredKeys.description = description;
          this.requiredKeys.flavour_type =
            categories.find((column) => column.name === "タイプ")?.name ??
            "N/A";
          this.requiredKeys.variant =
            categories.find((column) => column.name === "種類")?.name ?? "N/A";
          this.requiredKeys.volume =
            categories.find((column) => column.name === "容量")?.name ?? "N/A";
          this.requiredKeys.volume_variant =
            categories.find((column) => column.name === "容量バリアント")
              ?.name ?? "N/A";
          this.requiredKeys.child_items =
            categories.find((column) => column.name === "その他の容量項目")
              ?.name ?? "N/A";
          // this.requiredKeys.sweetness_dryness =
          //   categories.find((column) => column.name === "甘辛区分")?.name ??
          //   "N/A";
          // this.requiredKeys.intensity_type =
          //   categories.find((column) => column.name === "濃淡区分")?.name ??
          //   "N/A";
          // this.requiredKeys.ingredient_type =
          //   categories.find((column) => column.name === "特定名称")?.name ??
          //   "N/A";
          // this.requiredKeys.manufacturing_type =
          //   categories.find((column) => column.name === "製造区分")?.name ??
          //   "N/A";
          this.requiredKeys.recommended_way_to_consume =
            categories.find((column) => column.name === "飲み頃温度")?.name ??
            "N/A";
          this.requiredKeys.japanese_food =
            categories.find((column) => column.name === "和食")?.name ?? "N/A";
          this.requiredKeys.western_food =
            categories.find((column) => column.name === "洋食")?.name ?? "N/A";
          this.requiredKeys.chinese_and_ethnic_food =
            categories.find((column) => column.name === "中華_エスニック")
              ?.name ?? "N/A";
          this.requiredKeys.sweets_and_fruit =
            categories.find((column) => column.name === "スイーツ_フルーツ")
              ?.name ?? "N/A";
          this.requiredKeys.cafemenu_shopmenu_shibataproducts = 
            categories.find((column) => column.name === "菊水カフェメニュー_売店メニュー_新発田産品")
              ?.name ?? "N/A";
          this.requiredKeys.current_month = getCurrentMonthJapanese();
        })
        .catch((error) => {
          console.error("There was an error fetching the data!", error);
        })
        .finally(() => {});
    },

    animateProgress(newValue) {
      const animationDuration = 500; // milliseconds
      const fps = 60;
      const frameDuration = 1000 / fps;
      const totalFrames = animationDuration / frameDuration;

      let currentFrame = 0;
      const startValue = this.displayProgress;
      const changeInValue = newValue - startValue;

      const animate = () => {
        currentFrame++;
        const progress = currentFrame / totalFrames;
        this.displayProgress =
          startValue + changeInValue * this.easeOutCubic(progress);

        if (currentFrame < totalFrames) {
          requestAnimationFrame(animate);
        }
      };

      requestAnimationFrame(animate);
    },
    easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    },

    handleThumbsUp() {
      this.thumbsUp = true;
      this.thumbsDown = false;
      this.submitFeedback("positive");
      this.showFeedbackTextArea = true; // Show dialog for optional additional feedback
    },

    handleThumbsDown() {
      this.thumbsUp = false;
      this.thumbsDown = true;
      this.submitFeedback("negative");
      this.showFeedbackTextArea = true; // Show dialog for optional additional feedback
    },

    proceedWithFeedbackText() {
      let feedbackType = this.thumbsUp ? "positive" : "negative";
      if (this.feedbackText.trim()) {
        this.submitFeedback(feedbackType, this.feedbackText);
      }
      this.showFeedbackTextArea = false;
      this.feedbackText = "";
    },

    submitFeedback(feedbackType, message = null) {
      const conversationId = this.tasteProfileDetails.conversationId;
      const headers = {
        accept: "application/json",
        "project-key": this.credentialsFromData["projectKey"],
        "api-key": this.credentialsFromData["apiKey"],
      };

      // Only include message in the request body if it exists
      const feedbackRequestBody = {
        type: feedbackType,
        ...(message && { message: message }),
      };

      axios
        .put(
          `${process.env.VUE_APP_RECOMMENDER_API}/v1/gpt/conversations/${conversationId}`,
          feedbackRequestBody,
          { headers }
        )
        .then((response) => {
          console.log(response.data);
        });
    },

    generateLink() {
      try {
        const data = {
          userId: this.$root.userId,
          requestId: this.$root.requestId,
          conversationId: this.$root.conversationId,
          limit: this.currentQueryParamValue,
          commentIndex: this.lastSelectedCommentIndex,
        };

        const url = generateShareableLink(data, {
          // path: "/recommended-items",
          // secretKey: "custom-key",
          // baseUrl: "http://localhost:8082",
          // paramName: "token",
        });

        console.log("Generated shareable URL:", url);
        return url;
      } catch (error) {
        console.error("Error generating link:", error);
        this[SNACKBAR_NOTIFIER]({
          text: "Failed to generate link",
          color: "error",
        });
        return null;
      }
    },

    shareOnFacebook(url) {
      const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        url
      )}`;
      const newWindow = window.open(
        shareUrl,
        "facebook-share-dialog",
        "width=626,height=436"
      );
      if (newWindow) {
        newWindow.focus();
      } else {
        window.location.href = shareUrl;
      }
    },

    shareOnTwitter(url) {
      const title = document.title;
      const shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        title
      )}&url=${encodeURIComponent(url)}&via=Gigalogy&hashtags=蔵酒Match`;

      window.open(shareUrl, "twitter-share-dialog", "width=626,height=436");
    },

    shareOnLine(url) {
      const shareUrl = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(
        url
      )}`;
      window.open(shareUrl, "line-share-dialog", "width=626,height=436");
    },

    shareLink(platform) {
      const url = this.generateLink(); // Generates and returns the custom URL
      if (!url) return;

      switch (platform) {
        case "Facebook":
          this.shareOnFacebook(url);
          break;
        case "Twitter":
          this.shareOnTwitter(url);
          break;
        case "Line":
          this.shareOnLine(url);
          break;
        default:
          console.error("Unsupported platform");
      }
    },
  },
  watch: {
    currentStep(newStep) {
      if (newStep === 20) {
        this.isShowTasteProfileSectionMessage = true;
      }
    },
    progressCalculate: {
      handler(newValue) {
        this.animateProgress(newValue);
      },
      immediate: true,
      deep: true,
    },
    "$route.query.recommend_count": {
      handler(newValue, oldValue) {
        if (newValue) {
          // Update the local variable
          this.currentQueryParamValue = newValue;
        }
        // console.log("recommendationCount watch:", oldValue, "➡️", newValue);
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style>
:root {
  /* Title font sizes */
  --title-font-size-desktop: 1.5rem; /* 24px - Tailwind 2xl, Material XL */
  --title-font-size-tablet: 1.25rem; /* 20px - Tailwind XL, Bootstrap LG */
  --title-font-size-mobile: 1rem; /* 16px - Tailwind base, Bootstrap base */

  /* Question font sizes */
  --question-font-size-desktop: 1.5rem; /* 24px - Same as title desktop */
  --question-font-size-tablet: 1.125rem; /* 18px - Tailwind LG, Material MD */
  --question-font-size-mobile: 0.875rem; /* 14px - Tailwind SM, Bootstrap SM */

  /* Option font sizes */
  --option-font-size-desktop: 1.125rem; /* 18px - Tailwind LG, Material MD */
  --option-font-size-tablet: 0.875rem; /* 14px - Tailwind SM, Bootstrap SM */
  --option-font-size-mobile: 0.75rem; /* 12px - Tailwind XS, Material XS */
}

.v-list-item__title {
  display: block !important;
  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-break: break-word !important;
  text-overflow: unset !important;
  line-height: 1.4 !important;
  max-width: 100% !important;
}
</style>
<style scoped>
.app-bar {
  background-color: #005c9e !important;
}
.app-bar-logo__container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.app-bar-logo {
  height: 100%;

  padding: 4px 0px;
  transition: height 0.3s ease;
}
/* .footer-section {
  background-color: transparent !important;
  font-size: 13px;
  padding: 0px;
  margin: 0px;
  position: relative;
  
} */

.profile-explanation {
  font-weight: bold;
  line-height: 1.6rem;
}
.v-responsive__content {
  width: 100vh !important;
}
.home-container {
  padding: 0;
  margin-top: 4rem;
}
.green-heading-text {
  color: #006934;
}
.recommendation__container {
  margin: 0;
  padding: 0;
}
.sake-brewery-small-logo__container {
  width: 7.5rem;
  margin: 0 auto;
}
.questionnaire-content {
  padding: 0px;
}
.progressbar__container {
  margin: 0 auto;
  width: 43.75rem;
}
.stepper-form {
  margin: 0 1.563rem;
}
.stepper-content {
  margin: 1.5rem 0 0 0;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.taste-characteristics {
  text-align: center;
  padding: 0;
  font-weight: 800;
  list-style-type: none;
  padding-left: 0;
  font-size: 1.313rem;
}
.diagnose-brewery-logo__container {
  z-index: 1;
  width: 21.25rem;
}

.kurazake-title {
  font-size: 24px;
  font-weight: 500;
  display: block;
  margin: 0;
}

.diagnose-button {
  font-size: 18px;
  z-index: 1;
}

.v-progress-linear {
  transition: width ease-in-out;
}
.random-comment,
.pattern-type {
  font-size: 1.875rem !important;
  line-height: 1;
  text-align: center;
  font-weight: 800;
}
.pattern-type p {
  margin-bottom: 0;
}
.hvr-shutter-out-horizontal {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  position: relative;
  background: transparent;
  -webkit-transition-property: color;
  transition-property: color;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
}

.hvr-shutter-out-horizontal:before {
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #2098d1;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transform-origin: 50%;
  transform-origin: 50%;
  -webkit-transition-property: transform;
  transition-property: transform;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}

.hvr-shutter-out-horizontal.active {
  color: white;
}

.hvr-shutter-out-horizontal.active:before {
  -webkit-transform: scaleX(1);
  transform: scaleX(1);
}

.hvr-sweep-to-right {
  padding: 20px;
  background: lightgrey;
  display: inline-block;
  transform: perspective(1px) translateZ(0);
  position: relative;
  transition: color 0.3s;
}

.hvr-sweep-to-right:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: #2098d1;
  transform: scaleX(0);
  transform-origin: 0 50%;
  transition: transform 0.3s ease-out;
}

.hvr-sweep-to-right.active {
  color: white;
}

.hvr-sweep-to-right.active:before {
  transform: scaleX(1);
}

.taste-profile-start-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  font-size: 18px;
}

.continue-btn {
  padding: 5px 20px;
  background: transparent;
  color: white;
  border: 1px solid whitesmoke;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 20px;
}

.continue-btn:hover {
  background: linear-gradient(to right, #07f7f7, transparent);
}

.questionnaire-container {
  margin: 0px;
  padding: 0px;
}

.questionnaire-title {
  font-size: var(--title-font-size-desktop) !important;
  transition: all 0.3s ease;
  padding: 16px 20px !important;
}

.v-card__title {
  display: block !important;
}

.question-text {
  font-size: 1.5rem;
  transition: all 0.3s ease;
  line-height: 1.2 !important;
}

.option-text {
  font-size: 1.25rem !important;
  transition: all 0.3s ease;
  line-height: 1.2 !important;
}

.v-slide-group__content {
  display: block !important;
}

/* Mobile devices (max-width 600px is Vuetify's default breakpoint for mobile) */
@media screen and (max-width: 600px) {
  .diagnose-brewery-logo__container {
    z-index: 1;
    width: 70%;
    margin: 0 auto;
  }
  .kurazake-title {
    font-size: 22px;
  }
  .diagnose-button {
    z-index: 1;
    font-size: 16px;
    font-weight: bold;
    width: 80%;
  }
  .next-button {
    font-size: 16px;
    width: 90%;
  }
  .random-comment,
  .pattern-type {
    font-size: 1.25rem;
  }
  .progressbar__container {
    width: 90%;
  }
  .questionnaire-title {
    padding: 12px !important;
  }
  .question-text {
    font-size: 1.3rem !important;
    font-weight: bold;
    margin-bottom: 0.25rem;
  }
  .taste-characteristics {
    font-size: 1.25rem;
  }
  .stepper-content {
    margin: 0 !important;
  }
  .option-text {
    font-weight: bold;
    margin: 10px;
  }
  .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
    margin-bottom: 12px !important;
  }
  .v-stepper__content {
    padding: 16px 10px !important;
  }
  .custom-dropdown .v-input__control {
    border: 2px solid #b6afab;
    border-radius: 12px;
    padding: 6px 16px;
  }

  .custom-dropdown input {
    text-align: center;
    font-weight: bold;
    font-size: 18px;
  }

  .stepper-form {
    margin: 0 !important;
  }
}
</style>
